<isp-form-collapse
  [data]="to.data"
  [collapseTooltipMsg]="to.collapseTooltipMsg"
  [expandTooltipMsg]="to.expandTooltipMsg"
  (toggle)="emitPageCollapseEvent($event)"
  [class.page_is_hidden]="to.isHidden"
>
  <ng-container #fieldComponent></ng-container>
</isp-form-collapse>
